module.exports = function() {
  return new Worker(__webpack_public_path__ + "7fc8fc7859e01f4e2574.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./src/workers/alerts.worker.js
// module id = 93
// module chunks = 0